import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { clientConfig } from '../utilities/configService';

const reactPlugin = new ReactPlugin();

// Vite statically replaces import.meta.env.<KEY> and cannot resolve a dynamic
// bracket lookup, so map the known per-client AppInsights variable names explicitly.
const appInsightsConnectionStrings: Record<string, string | undefined> = {
    REACT_APP_APP_INSIGHTS_ICFDEMO: import.meta.env.REACT_APP_APP_INSIGHTS_ICFDEMO,
    REACT_APP_APP_INSIGHTS_CENHUD: import.meta.env.REACT_APP_APP_INSIGHTS_CENHUD,
    REACT_APP_APP_INSIGHTS_AMERENIL: import.meta.env.REACT_APP_APP_INSIGHTS_AMERENIL,
};

const connectionString = clientConfig?.APP_INSIGHTS_VARIABLE_NAME
    ? appInsightsConnectionStrings[clientConfig.APP_INSIGHTS_VARIABLE_NAME]
    : import.meta.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

const appInsights = new ApplicationInsights({
    config: {
        connectionString: connectionString,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        disableCorrelationHeaders: true,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        disableFetchTracking: false,
    }
});

appInsights.loadAppInsights();

export { reactPlugin, appInsights };
